<div class="card-header bg-light">
    <h3 class="card-title mb-0">
        <i class="fas fa-search pr-2"></i>
        {{ tituloModal }}
    </h3>
</div>

<div class="card-body">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm">
        <div class="row mb-2">
            <div class="col-md-12 mb-2">
                <label for="inputTitulo" class="mb-1">Título</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputTitulo" class="form-control form-control-sm" maxlength="200"
                        [value]="model.recomendacao.titulo" readonly />
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputDescricao" class="mb-1">Descrição</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <textarea class="form-control" rows="5" maxlength="1000" name="inputDescricao" readonly
                        [value]="model.recomendacao.descricao">
                    </textarea>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="card-footer">
    <div class="d-flex justify-content-between w-100">
        <button type="button" class="btn btn-default btn-sm" (click)="fechar()">
            <i class="fas fa-times"></i> Sair
        </button>
    </div>
</div>